(function () {
  const block = {
    $blocks: document.querySelectorAll('.tjh_marquee'),
    defaultSpeed: 80,
    mobileBreakpoint: 768,
    init() {
      if (!this.$blocks.length) {
        return;
      }

      this.$blocks.forEach($block => {
        this.setUpMarquee($block);
      });
    },

    getSpeed($block) {
      const isMobile = window.innerWidth <= this.mobileBreakpoint;
      const speed = parseFloat(
        isMobile ? $block.dataset.marquee_speed_mobile : $block.dataset.marquee_speed
      );

      if (speed > 0) {
        return speed;
      }

      const fallbackSpeed = parseFloat($block.dataset.marquee_speed);

      return fallbackSpeed > 0 ? fallbackSpeed : this.defaultSpeed;
    },

    updateMetrics($block) {
      const $track = $block.querySelector('.inner_wrapper > .track');

      if (!$track) {
        return;
      }

      const trackWidth = $track.scrollWidth;
      const speed = this.getSpeed($block);

      if (!trackWidth || !speed) {
        return;
      }

      $block.style.setProperty('--track-width', trackWidth + 'px');
      $block.style.setProperty('--marquee-duration', (trackWidth / speed) + 's');
    },

    setUpMarquee($block) {
      const $wrapper = $block.querySelector('.inner_wrapper');
      const $track = $wrapper?.querySelector('.track');

      if (!$wrapper || !$track || $wrapper.dataset.marqueeReady) {
        return;
      }

      const trackWidth = $track.scrollWidth;

      if (!trackWidth) {
        return;
      }

      $wrapper.append($track.cloneNode(true));
      $wrapper.dataset.marqueeReady = 'true';

      const updateMetrics = () => {
        this.updateMetrics($block);
      };

      updateMetrics();

      new ResizeObserver(updateMetrics).observe($track);
      window.addEventListener('resize', updateMetrics);
    }
  };

  block.init();
})();
